export var VERSION = '2.17.12';
//# sourceMappingURL=version.js.map